import { render, staticRenderFns } from "./ProtocolloRubricaList.vue?vue&type=template&id=3e8da8b0"
import script from "./ProtocolloRubricaList.vue?vue&type=script&lang=js"
export * from "./ProtocolloRubricaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports